import UploadFile from './UploadFile';
export default UploadFile;
